import { Context, Plugin } from '@segment/analytics-node'
import { processEventProperties } from '../helpers/eventPropertiesProcessor'
import { BrazeInAppConfiguration, SegmentEventData } from '../types'

/**
 * Creates a Braze tracking plugin for Segment Analytics
 * @param inAppConfiguration - Optional configuration for in-app messaging behavior
 * @returns Segment Plugin for Braze event tracking
 */
export const createBrazeTrackingPlugin = (
  inAppConfiguration?: BrazeInAppConfiguration
): Plugin => ({
  name: 'BrazeTrack',
  version: '1.0.0',
  isLoaded: () => !!window?.braze,
  type: 'enrichment',
  load: () => Promise.resolve(),

  track: (ctx: Context) => {
    if (!window?.braze) {
      console.warn('Braze is not available on window object')
      return ctx
    }

    if (!ctx?.event) {
      console.warn('Invalid context: missing event data')
      return ctx
    }

    const {
      event: { event, anonymousId, properties = {} }
    } = ctx

    const eventData: SegmentEventData = {
      event,
      anonymousId,
      properties,
      userId: anonymousId,
      source: '@segment/analytics-node',
      trackId: properties?.trackId
    }

    const processed = processEventProperties(eventData, inAppConfiguration)

    try {
      if (processed !== null) {
        window.braze.logCustomEvent(`NFA ${processed.event}`, processed.attr)
      }
    } catch (error) {
      console.warn('Braze segment plugin error:', error)
    }

    return ctx
  }
})

export default createBrazeTrackingPlugin
